<template>
  <div>
    <div>
      <div v-if="state!=null">
        <v-icon large color="#0b2822" v-if="this.data.feedBack==1">mdi-emoticon-outline</v-icon>
        <v-icon large color="#471f1f" v-if="this.data.feedBack==0">mdi-emoticon-sad-outline</v-icon>
      </div>
      <div v-else>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon large v-bind="attrs" v-on="on" color="#60D3BC" @click="sendFeedBack(1)">mdi-emoticon-outline
            </v-icon>
          </template>
          <span>خوب راضی ام</span>
        </v-tooltip>


        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon large color="#E06465" v-bind="attrs" v-on="on" class="cursor-pointer" @click="sendFeedBack(0)">
              mdi-emoticon-sad-outline
            </v-icon>
          </template>
          <span>بد راضی نیستم</span>
        </v-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.state = this.data.feedBack
  },
  data() {
    return {
      state: null,
    }
  },
  methods: {
    sendFeedBack(type) {
      this.loading = true;
      this.requestApiPost('ticketFeedback', {
        ticket_id: this.data.id,
        feedback: type,
      }).then((response) => {
        this.action(true, 'showListAgain')
        this.loading = false;
        this.$toast.success('نظر شما با موفقیت ثبت شد.');
      }).catch(({response}) => {
        this.errors = response.data;
        this.loading = false;
      });
    },
  },
  props: {
    data: {},
    feedback: String,
    action: {
      type: Function
    }, meta: {
      type: Object
    }
  },


}
</script>
